import { makePropGetter as makeAppStatePropGetter, createPropGetterMaker } from './common'


const getPricesListState = makeAppStatePropGetter('pricesList')
const makePropGetter = createPropGetterMaker(getPricesListState)

export const topPricesSelector = makePropGetter('top')
export const pricesByMonthSelector = makePropGetter('byMonth')
export const pricesByDaySelector = makePropGetter('byDay')
